import { EStoryType } from 'reactApp/modules/stories/stories.types';

export const STORIES_LIST_API_LIMIT = 10;
export const SUPPORTED_STORY_TYPES = [EStoryType.historyStory, EStoryType.selectionStory, EStoryType.flashbackStory];
